import Paper from "@mui/material/Paper";
import React from 'react';
import { searchStyleAutocompletePopover } from '../SearchBar.style';
export const CustomPaper = (props) => {
    return (React.createElement(Paper, Object.assign({ sx: searchStyleAutocompletePopover }, props)));
};
